'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports['default'] = NotFound;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./NotFound.scss');

function NotFound() {
  var notFoundImage = require('../../assets/images/404.svg');
  return _react2['default'].createElement(
    'div',
    { className: 'page-content page-content--not-found' },
    _react2['default'].createElement(
      'div',
      { className: 'container' },
      _react2['default'].createElement(
        'div',
        { className: 'row' },
        _react2['default'].createElement(
          'div',
          { className: 'col-xs-12 col-md-8 col-md-offset-2' },
          _react2['default'].createElement(
            'div',
            { className: 'not-found' },
            _react2['default'].createElement('img', { className: 'not-found__img', src: notFoundImage, alt: '404' }),
            _react2['default'].createElement(
              'span',
              { className: 'not-found__caption' },
              'Looks like this page doesn\'t exist.'
            )
          )
        )
      )
    )
  );
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 676
// module chunks = 0